<ng-container *ngIf="bookings.length === 0">
    <ng-container *ngTemplateOutlet="emptyState">
    </ng-container>
</ng-container>
<ng-container *ngIf="bookings.length > 0">
    <ng-container *ngTemplateOutlet="content">
    </ng-container>
</ng-container>

<ng-template #emptyState>
    <h4
        class="p-3 text-center"
    >
        No Bookings
    </h4>
</ng-template>

<ng-template #content>
    <div class="bg-body" [ngClass]="{'compact': size === 'compact'}">
        <table
            class="table table-responsive table-hover mb-0"
            [ngClass]="{'table-compact': size === 'compact'}"
        >
            <thead class="sticky-top top-0 text-nowrap">
            <tr>
                <th class="ps-3" [ngClass]="{'py-1': size === 'compact'}">
                    Name
                </th>
                @if (showDateBooked) {
                <th class="text-center" [ngClass]="{'py-1': size === 'compact'}">
                    Booked
                </th>
                }
                <th class="text-center" [ngClass]="{'py-1': size === 'compact'}">
                    Covers
                </th>
                @if (showBookingDateTime) {
                <th class="text-center" [ngClass]="{'py-1': size === 'compact'}">
                    Start
                </th>
                }
                @if (showBookingTime) {
                <th class="text-center" [ngClass]="{'py-1': size === 'compact'}">
                    Start
                </th>
                }
                <th class="text-center" [ngClass]="{'py-1': size === 'compact'}">
                    Status
                </th>
            </tr>
            </thead>
            <tbody>
            <tr
                *ngFor="let booking of bookings"
                role="button"
                (click)="bookingClicked(booking)"
                [ngClass]="{'compact-row': size === 'compact'}"
            >
                <ng-container
                    [ngTemplateOutlet]="getRowTemplate(booking)"
                    [ngTemplateOutletContext]="{ $implicit: booking }"
                >
                </ng-container>
            </tr>
            </tbody>
        </table>
    </div>
</ng-template>

<ng-template
    #bookingRow
    let-booking
>
    <td class="align-middle ps-3 pe-2" [ngClass]="{'py-1': size === 'compact'}">
        @if (booking.isWalkIn()) {
            {{ 'Walk-In' }}
        } @else {
            {{ booking.name }}
        }
    </td>
    @if (showDateBooked) {
        <td class="text-nowrap text-center align-middle pe-2" [ngClass]="{'py-1': size === 'compact'}">
            <div class="vstack justify-content-around">
                <span>{{ booking.dateCreated | date: 'HH:mm' }}</span>
                <span>{{ booking.dateCreated | date: 'dd MMM' }}</span>
            </div>
        </td>
    }
    <td class="text-center align-middle pe-2" [ngClass]="{'py-1': size === 'compact'}">
        <app-party-size-badge
            [partySize]="booking.size"
            [statusType]="BookingStatusType.Finished"
        >
        </app-party-size-badge>
    </td>
    @if (showBookingDateTime) {
        <td class="text-nowrap text-center align-middle pe-2" [ngClass]="{'py-1': size === 'compact'}">
            <div class="vstack justify-content-around">
                <span>{{ booking.start | date: 'HH:mm a' }},</span>
                <span>{{ booking.start | date: 'dd MMM' }}</span>
            </div>
        </td>
    }
    @if (showBookingTime) {
        <td class="text-nowrap text-center align-middle pe-2" [ngClass]="{'py-1': size === 'compact'}">
            <div class="vstack justify-content-around">
                <span>{{ booking.start | date: 'shortTime' }}</span>
            </div>
        </td>
    }
    <td class="text-nowrap text-center align-middle" [ngClass]="{'py-1': size === 'compact'}">
        <app-booking-status-badge
            [statusType]="booking.status().type"
            [showNotificationIndicator]="booking.canChargeCancellationFee()"
            [ngbTooltip]="booking.canChargeCancellationFee() ? 'Chargeable' : ''"
            container="body"
        >
            {{ booking.status().type | bookingStatusName }}
        </app-booking-status-badge>
    </td>
</ng-template>

<ng-template
    #uncompletedBookingRequestRow
    let-request
>
    <td class="align-middle ps-3 pe-2" [ngClass]="{'py-1': size === 'compact'}">
        {{ request.contact.name }}
    </td>
    @if (showDateBooked) {
        <td class="text-nowrap text-center align-middle pe-2" [ngClass]="{'py-1': size === 'compact'}">-</td>
    }
    <td class="text-center align-middle pe-2" [ngClass]="{'py-1': size === 'compact'}">
        <app-party-size-badge
            [partySize]="request.partySize"
            [statusType]="BookingStatusType.Finished"
        >
        </app-party-size-badge>
    </td>
    @if (showBookingDateTime) {
        <td class="text-nowrap text-center align-middle pe-2" [ngClass]="{'py-1': size === 'compact'}">
            <div class="vstack justify-content-around">
                <span>{{ request.bookingSlot.dateTime | date: 'HH:mm a' }},</span>
                <span>{{ request.bookingSlot.dateTime | date: 'dd MMM' }}</span>
            </div>
        </td>
    }
    @if (showBookingTime) {
        <td class="text-nowrap text-center align-middle pe-2" [ngClass]="{'py-1': size === 'compact'}">
            <div class="vstack justify-content-around">
                <span>{{ request.bookingSlot.dateTime | date: 'shortTime' }}</span>
            </div>
        </td>
    }
    <td class="text-nowrap text-center align-middle" [ngClass]="{'py-1': size === 'compact'}">
        <div
            class="badge bg-warning bg-opacity-10 text-warning-emphasis rounded-2 fs-4"
            [style.padding]="'3px 0.5rem'"
            [style.line-height]="'1.5'"
        >
            Uncompleted
        </div>
    </td>
</ng-template>
